var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "closebtn-broker-app pointer",
    on: {
      "click": function click($event) {
        return _vm.restoreApplication();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/images/refresh-icon.svg"),
      "loading": "lazy",
      "width": "10px",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "ziadost-icon justify-content-start"
  }, [_vm.object.bank ? _c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": _vm.object.bank.logo_square,
      "loading": "lazy",
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "text-part mr-3"
  }, [_c('div', {
    staticClass: "bold black--text"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.object.suma_bezucel + _vm.object.suma_refinancovanie + _vm.object.suma_nadobudnutie)) + " €")]), _c('div', {
    staticClass: "bold black--text font-size-12"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm._f("toFloor")(_vm.object.splatka))) + " €")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }